import { useState } from "react";
import { connect } from "react-redux";
import writeXlsxFile from "write-excel-file";

import dict from "../../Data/dict.json";
import is_not_empty from "./is_not_empty";
import { data_types } from "./data_types";

import logo_xlsx from "../../Assets/svg/logo_xlsx.svg";
import { CircularProgress } from "@mui/material";

import fields_default from "../../Data/fields_default.json";

import { post_activities } from "../actions/activities";

const DownloadExcel = ({ layer, post_activities }) => {
  const [loading, setLoading] = useState(false);

  const download_excel = async () => {
    const { layer_id, geo_layer_list, sorted_by } = layer;

    post_activities({
      action: "download_excel",
      layer_id,
    });
    const geo_layer = geo_layer_list.find(
      (e) => e?.geo_layer?._id === layer_id,
    );
    const language = localStorage?.language ? localStorage?.language : "ina";

    let fields_layer = geo_layer?.geo_layer?.fields
      ? geo_layer?.geo_layer?.fields
      : [];

    let will_be_removed_types = [];
    Object.keys(fields_default).forEach((f) => {
      fields_default[f].forEach((i) => will_be_removed_types.push(i.key));
    });
    will_be_removed_types = [...new Set(will_be_removed_types)];

    fields_layer = fields_layer.filter(
      (d) => !will_be_removed_types.includes(d.key),
    );

    let features_filtered =
      geo_layer?.geo_layer?.geojson_filtered?.features || [];

    let field, sort;
    if (sorted_by?.length > 0) {
      field = sorted_by?.[0]?.field;
      sort = sorted_by?.[0]?.sort;

      const isFromSmall = sort === "desc" ? false : true;
      const key = field;
      features_filtered = features_filtered.sort((a, b) => {
        if (a?.properties?.[key] < b?.properties?.[key])
          return isFromSmall ? -1 : 1;
        if (a?.properties?.[key] > b?.properties?.[key])
          return isFromSmall ? 1 : -1;
        return 0;
      });
    }

    let fields = fields_layer;

    try {
      setLoading(true);
      let schema = [
        {
          column: "No", // Tambahkan kolom nomor
          type: Number,
          value: (data) => data.no, // Index + 1 untuk nomor urut
        },
        ...fields.map((d) => {
          const object_type = data_types(language).find(
            (i) => i?.value === d?.type,
          );

          const { js_data_type, format_date } = object_type;

          let body = {
            column: d.name?.trim() ?? "Unnamed",
            type: js_data_type,
            value: (data) => {
              let new_data = data[d.key];

              if (js_data_type === Number) {
                if (!data[d.key]) return 0;
              } else if (js_data_type === Date) {
                const temp_date = new Date(data[d.key]);
                if (temp_date instanceof Date && isNaN(temp_date)) return "";
              }

              if (object_type?.callback && new_data)
                return object_type?.callback(data[d.key]);
              else if (object_type?.callback && !new_data) return "";
              else if (js_data_type === String) return String(new_data).trim();

              return js_data_type(new_data);
            },
          };
          if (format_date && js_data_type === Date) body.format = format_date;

          return body;
        }),
      ];

      const key = fields.map((d) => d.key);

      const newData = features_filtered.map((d, index) => {
        let obj = {};
        for (let index = 0; index < key.length; index++) {
          const element = key[index];

          if (d?.properties?.[element] !== undefined) {
            obj[element] = d?.properties?.[element];
          } else if (
            d?.child_array?.map((m) => m?.properties?.[element]) !== undefined
          ) {
            obj[element] = String(
              d?.child_array?.map((m) => m?.properties?.[element]),
            );
          }

          let properties = "";
          if (is_not_empty(d?.properties?.[element])) {
            if (!isNaN) {
              properties = +d?.properties?.[element];
            } else {
              properties = d?.properties?.[element];
            }
          }

          let properties_child = "";
          if (is_not_empty(d?.child_array?.[0]?.properties?.[element])) {
            if (!isNaN) {
              properties = +d?.child_array?.[0]?.properties?.[element];
            } else {
              properties = d?.child_array?.[0]?.properties?.[element];
            }
          }

          if (d?.properties?.[element] !== undefined) {
            obj[element] = String(properties);
          } else if (d?.child_array?.[0]?.properties?.[element] !== undefined) {
            obj[element] = String(properties_child);
          }
        }

        const body = {
          ...obj,
          longitude: String(d.geometry.coordinates[0]),
          latitude: String(d.geometry.coordinates[1]),
          no: index + 1,
        };
        return d.geometry.type === "Point" ? body : obj;
      });

      await writeXlsxFile(newData, {
        schema,
        fileName: geo_layer.geo_layer.name,
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const language = localStorage?.language ? localStorage?.language : "ina";

  return (
    <button
      onClick={() => download_excel()}
      data-mapid="clickDownloadExcel"
      title={dict?.["Download Excel"]?.[language]?.toUpperCase()}
      className="button_download_data"
    >
      {loading ? (
        <CircularProgress size={20} thickness={8} sx={{ color: "black" }} />
      ) : (
        <img src={logo_xlsx} width={40} alt="icon download xlsx" />
      )}
      <p className="layer_action_label inactive_label">XLSX</p>
    </button>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
});

export default connect(mapStateToProps, { post_activities })(DownloadExcel);
